import React, { useState } from 'react';
import NgoLayout from "../../../../layouts/Ngo/NgoLayout";
import '../../../../assets/css/Ngo/controlpanelCSS/ngoFundwallet.css';
import { DollarSign, HandHeart, Clock, FileText, User, File, Banknote, Eye } from 'lucide-react';



const NgoFundsOverview = () => {
  const [selectedProof, setSelectedProof] = useState(null);

  // Stats Data
  const stats = [
    {
      title: 'Total Donations',
      amount: 'Rs 15,20,000',
      icon: DollarSign,
      color: 'primary'
    },
    {
      title: 'Total Distributed',
      amount: 'Rs 12,00,000',
      icon: HandHeart,
      color: 'success'
    },
    {
      title: 'Pending Disbursement',
      amount: 'Rs 3,20,000',
      icon: Clock,
      color: 'warning'
    },
    {
      title: 'Active Funded Cases',
      amount: '8',
      icon: FileText,
      color: 'info'
    }
  ];

  // Donation History
  const donationHistory = [
    {
      id: 1,
      date: '15 Apr',
      donor: 'Hafsa',
      studentCase: 'Case #123',
      amount: '800'
    },
    {
      id: 2,
      date: '15 Apr',
      donor: 'Noman',
      studentCase: 'Case #124',
      amount: '800'
    },
    {
      id: 3,
      date: '10 Apr',
      donor: 'Ahmed',
      studentCase: 'Case #125',
      amount: '25,000'
    }
  ];

  // Pending Disbursements
  const pendingDisbursements = [
    {
      id: 1,
      student: 'Ayesha Khan',
      amount: 'Rs 12,500',
      method: 'EasyPaisa'
    },
    {
      id: 2,
      student: 'Ali Raza',
      amount: 'Rs 8,000',
      method: 'JazzCash'
    },
    {
      id: 3,
      student: 'Sara Ahmed',
      amount: 'Rs 25,000',
      method: 'Bank Transfer'
    }
  ];

  // Disbursement History
  const disbursementHistory = [
    {
      id: 1,
      date: '14 Apr',
      student: 'Ayesha Khan',
      amount: '12,500',
      method: 'EasyPaisa',
      status: 'Sent',
      statusType: 'success'
    },
    {
      id: 2,
      date: '10 Apr',
      student: 'Ali Raza',
      amount: '9,000',
      method: 'JazzCash',
      status: 'Send',
      statusType: 'warning'
    },
    {
      id: 3,
      date: '08 Apr',
      student: 'Sara Ahmed',
      amount: '25,000',
      method: 'Bank Transfer',
      status: 'Send',
      statusType: 'warning'
    }
  ];

  // New Donations
  const newDonations = [
    { date: '12 Apr', amount: '6,000' },
    { date: '10 Apr', amount: '9,000' },
    { date: '08 Apr', amount: '15,000' }
  ];

  // Handle Send
  const handleSend = (student) => {
    alert(`Sending payment to ${student}`);
  };

  // Handle View Proof
  const handleViewProof = (id) => {
    setSelectedProof(id);
    alert(`Viewing proof for disbursement ID: ${id}`);
  };

  return (
    <NgoLayout>
      <div className="ngo-funds-container">
        <div className="ngo-funds-wrapper">
          {/* Header */}
          <div className="ngo-funds-header">
            <h1 className="ngo-funds-title">NGO Funds Overview</h1>
          </div>

          {/* Stats Cards */}
          <div className="ngo-funds-stats-grid">
            {stats.map((stat, index) => {
              const IconComponent = stat.icon;
              return (
                <div key={index} className="ngo-funds-stat-card">
                  <div className="ngo-funds-stat-content">
                    <div className="ngo-funds-stat-info">
                      <p className="ngo-funds-stat-label">{stat.title}</p>
                      <p className="ngo-funds-stat-value">{stat.amount}</p>
                    </div>
                    <div className={`ngo-funds-stat-icon ngo-funds-stat-icon-${stat.color}`}>
                      <IconComponent className="ngo-funds-icon" />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Two Column Layout */}
          <div className="ngo-funds-two-col-grid">
            {/* Donation History */}
            <div className="ngo-funds-card">
              <h2 className="ngo-funds-card-title">Donation History</h2>
              <div className="ngo-funds-table-wrapper">
                <table className="ngo-funds-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Donor</th>
                      <th>Student / Case</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {donationHistory.map((item) => (
                      <tr key={item.id}>
                        <td>{item.date}</td>
                        <td>
                          <div className="ngo-funds-cell-with-icon">
                            <User className="ngo-funds-cell-icon" />
                            {item.donor}
                          </div>
                        </td>
                        <td>
                          <div className="ngo-funds-cell-with-icon">
                            <File className="ngo-funds-cell-icon" />
                            {item.studentCase}
                          </div>
                        </td>
                        <td>
                          <div className="ngo-funds-cell-with-icon">
                            <Banknote className="ngo-funds-amount-icon" />
                            {item.amount}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Pending Disbursements */}
            <div className="ngo-funds-card">
              <h2 className="ngo-funds-card-title">Pending Disbursements</h2>
              <div className="ngo-funds-table-wrapper">
                <table className="ngo-funds-table">
                  <thead>
                    <tr>
                      <th>Student</th>
                      <th>Amount Pending</th>
                      <th>Method</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pendingDisbursements.map((item) => (
                      <tr key={item.id}>
                        <td>{item.student}</td>
                        <td className="ngo-funds-amount-pending">{item.amount}</td>
                        <td>{item.method}</td>
                        <td>
                          <button 
                            className="ngo-funds-btn-send"
                            onClick={() => handleSend(item.student)}
                          >
                            Send
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Bottom Section - Two Columns */}
          <div className="ngo-funds-bottom-grid">
            {/* Disbursement History */}
            <div className="ngo-funds-card ngo-funds-card-large">
              <h2 className="ngo-funds-card-title">Disbursement History</h2>
              <div className="ngo-funds-table-wrapper">
                <table className="ngo-funds-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Student</th>
                      <th>Amount</th>
                      <th>Method</th>
                      <th>Status</th>
                      <th>Proof</th>
                    </tr>
                  </thead>
                  <tbody>
                    {disbursementHistory.map((item) => (
                      <tr key={item.id}>
                        <td>{item.date}</td>
                        <td>{item.student}</td>
                        <td className="ngo-funds-amount-value">{item.amount}</td>
                        <td>{item.method}</td>
                        <td>
                          <span className={`ngo-funds-status-badge ngo-funds-status-${item.statusType}`}>
                            {item.status}
                          </span>
                        </td>
                        <td>
                          <button 
                            className="ngo-funds-btn-view"
                            onClick={() => handleViewProof(item.id)}
                          >
                            <Eye className="ngo-funds-btn-icon" />
                            View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="ngo-funds-table-footer">
                Showing 3 of 48
              </div>
            </div>

            {/* New Donations Received */}
            <div className="ngo-funds-card">
              <h2 className="ngo-funds-card-title">New Donations Received</h2>
              <div className="ngo-funds-donations-summary">
                <div className="ngo-funds-donations-total">Rs 3,20,000</div>
                <div className="ngo-funds-donations-count">3 new donations</div>
              </div>
              <div className="ngo-funds-donations-list">
                {newDonations.map((donation, index) => (
                  <div key={index} className="ngo-funds-donation-item">
                    <span className="ngo-funds-donation-date">{donation.date}</span>
                    <span className="ngo-funds-donation-amount">{donation.amount}</span>
                    <span className="ngo-funds-donation-check">✓</span>
                  </div>
                ))}
              </div>
              <button className="ngo-funds-btn-view-all">
                View All 
                <span className="ngo-funds-arrow">›</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </NgoLayout>
  );
};

export default NgoFundsOverview;

